<template>
    <div class="wrapper" :class="[
                  { 'nav-open': $sidebar.showSidebar },
                  { rtl: $route.meta.rtlActive }
                ]">
        <notifications></notifications>
        <side-bar :active-color="sidebarBackground" :background-image="sidebarBackgroundImage" :data-background-color="sidebarBackgroundColor">
            <user-menu></user-menu>
            <mobile-menu></mobile-menu>
            <template slot="links">
                  
                  <!--
                    <sidebar-item
                      :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
                    >
                    </sidebar-item>
                    -->
            
                     <sidebar-item  v-for="(item, index) in menus"  :key="index" 
                                   :link="getLinkPai(item)" >
            
                                 <sidebar-item   v-for="(subitem, subindex) in item.children" :key="subindex"
                                            :link="getLink(subitem, item)" ></sidebar-item>
                     </sidebar-item>
</template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <fixed-plugin v-if="false"
        :color.sync="sidebarBackground"
        :colorBg.sync="sidebarBackgroundColor"
        :sidebarMini.sync="sidebarMini"
        :sidebarImg.sync="sidebarImg"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";
import service from "../../../services/MenuService";

import mixinuser from '../../../library/mixin/user.js';

export default {
    components: {
        TopNavbar,
        ContentFooter,
        MobileMenu,
        FixedPlugin,
        UserMenu,
        ZoomCenterTransition
    },
    mixins: [mixinuser],
    data() {
        return {
            sidebarBackgroundColor: "white",
            sidebarBackground: "orange",
            sidebarBackgroundImage: "./img/sidebar.jpg",
            sidebarMini: true,
            sidebarImg: true,
            menus: [], 
        };
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        },
        getLinkPai(item){

            if ( item.children != null && item.children != undefined &&  item.children.length > 0 ){
                   return { name: item.name, icon: item.icon } ;  
            }else{
                  return { name: item.name, path: item.path , icon: item.icon };
            }


        },
        getLink(subitem, item) {
            return { name: subitem.name, path: item.path + "/" + subitem.path, icon: subitem.icon };
        }
    },
    mounted() {
        
   

        var user = this.getGlobalUser();
       // console.log("Siedebar?? "); console.log(  this.$sidebar );

        this.menus = service.getMenu(user.perfil_codigo, user.perfil); //rrend onde traz o menu
        //console.log("Menus? "); console.log( this.menus );

        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith("Win");
        if (isWindows) {
            // if we are on windows OS we activate the perfectScrollbar function
            initScrollbar("sidebar");
            initScrollbar("sidebar-wrapper");
            initScrollbar("main-panel");

            docClasses.add("perfect-scrollbar-on");
        } else {
            docClasses.add("perfect-scrollbar-off");
        }

        this.$sidebar.displaySidebar(false); //Deixando o menu já aberto..
        this.$sidebar.toggleMinimize();

    },
    watch: {
        sidebarMini() {
            this.minimizeSidebar();
        }
    }
};
</script>